<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <BankingDetails :companyID="companyID"></BankingDetails>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import BankingDetails from "../../components/audit/CheckBankingDetails.vue";

export default {
    components: {
        BankingDetails
    },
    props: [
        'companyID'
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        
    },
    created() {
    }
};
</script>

<style>

</style>
